module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingResult/images/landing-result-award.RU.0061d88a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingResult/images/landing-result-award.RU.png
// module id = 3140
// module chunks = 11